// removed by extract-text-webpack-plugin
module.exports = {"container":"VbnjanM","welcome":"_2T5vKuV","link":"_1k1reGo","links":"_1GV6Ntf","pipe":"_1tXI178"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Greeter/index.css
// module id = ./template/components/Greeter/index.css
// module chunks = client.sitechrome